var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.9998 0C30.9582 0 0.000976562 30.9512 0.000976562 68.9976C0.000976562 107.044 30.9562 138 68.9998 138C107.05 138 137.999 107.046 137.999 68.9976C137.999 30.9512 107.052 0 68.9998 0ZM98.8623 54.8607L62.7252 90.9977C61.6402 92.0815 60.2103 92.6287 58.7936 92.6287C57.3661 92.6287 55.9495 92.0819 54.8608 90.9977L39.1445 75.2814C36.9716 73.1065 36.9716 69.5887 39.1445 67.4162C41.317 65.2437 44.8348 65.2437 47.0077 67.4162L58.7936 79.2061L91.0039 46.9942C93.172 44.8242 96.6894 44.8242 98.8623 46.9942C101.035 49.1704 101.035 52.6882 98.8623 54.8607Z",
    fill: "#23FACF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.0bcb612ebdc253af75486af64930bb78.svg";
export { ForwardRef as ReactComponent };